// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"227":"a3ebec7c","888":"85d7b587"}[chunkId] + ".js";
};